import React, { useEffect, useState } from 'react';
import { Col } from 'reactstrap';
import InputComponent from '../InputComponent';

const TextInput = (props) => {
    const [isValid, setIsValid] = useState(true);

    // Handle input change and validation
    const onInputChanged = (e) => {
        const value = e.target.value;
        props.changed(value);

        // Perform validation
        if (props.isMandate && !value.trim()) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    };

    useEffect(() => {
        if (props.disable && !props.assessmentCompleted && props.value) {
            props.changed('');
        }
    }, [props]);

    const handleBlur = () => {
        if (props?.isMandate) {
            props.handleOnBlur(isValid, props.placeholder);
        } else {
            props.handleOnBlur();
        }
    };

    // Placeholder text logic
    const getPlaceholderText = () => {
        let placeholder = props.placeholder || props.questionText || 'Enter your text';
        placeholder = placeholder.trim();
        if (props.isMandate) return `${placeholder} *`;
        else return placeholder;
    };

    return (
        <React.Fragment>
            {props.type === 118 ? (
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="pe-0 mt-0">
                    <div className="input-container">
                        <InputComponent
                            id={props.answerInternalIdentifier}
                            name={props.questionId}
                            value={props.value}
                            type="text"
                            className={`input-default w-100 ${!isValid ? 'input-invalid' : ''}`}
                            placeholder={getPlaceholderText()}
                            invalid={props.error?.[props.questionId] || !isValid}
                            onChange={onInputChanged}
                            disabled={props.disable}
                            onBlur={handleBlur}
                        />
                        {/* {props.isMandate && <span className="mandatory-asterisk">*</span>} */}
                    </div>
                    {/* {!isValid && <p className="text-danger">This field is required.</p>} */}
                </Col>
            ) : (
                <InputComponent
                    id={props.answerInternalIdentifier}
                    name={props.questionId}
                    value={props.value}
                    type="text"
                    className={`input-default w-100 ${!isValid ? 'input-invalid' : ''}`}
                    placeholder={getPlaceholderText()}
                    invalid={props.error?.[props.questionId] || !isValid}
                    onChange={onInputChanged}
                    disabled={props.disable}
                    onBlur={props.handleOnBlur}
                />
            )}
        </React.Fragment>
    );
};

export default TextInput;
